import React, { useState, useEffect, useRef, useMemo, createRef } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { AuctionUWUnderwriterSelector } from 'components/underwrite/acquisition/auctionUnderwrite';
import LaunchValuationButton from './LaunchValuationButton'
import { OpportunityStatusChip, BoolIcon } from 'components/layout';
import TerminateModal from 'components/underwrite/acquisition/channelWorkflow/TerminateModal';
import AssignModal from 'components/underwrite/shared/workflow/AssignModal';
import {
  setConfirmationModalState,
  syncPurchaseState,
  terminateTxnOpps,
  unterminateTxnOpps,
  deleteTxnOpps,
  setAuctionUWMarkerState,
  runAutoCalc,
  setAuctionGridCurrentViewData,
  setViewValuationDialogProps,
  toggleViewValuationDialogIsOpen,
  orderInspection,
  updateBidInPrism,
  updateVisibleTxnOpps,
  refreshTxnInspection,
  unassignTasks,
  setSaveUWDialogParameters,
  setAuctionUWMapState,
  setAuctionGridState,
  appNotify,
  assignTasksTo
} from 'store/actions';
import {
  selectedAuctionTxnOppsSelector
} from 'store/selectors';
import { Constants } from 'utilities/constants';
import {
  Column,
  Paging,
  SearchPanel,
  Sorting,
  Selection,
  FilterPanel,
  HeaderFilter,
  ColumnChooser,
  ColumnFixing,
  Export,
  FilterBuilder
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import DataGrid from 'components/devExtreme/DataGrid';
import { InspectionDialog } from 'components/underwrite/acquisition';
import Query from "devextreme/data/query";
import { sendClientLog } from 'services/logService';
import CloseIcon from '@material-ui/icons/Close';
import FullscreenDialog from 'components/layout/FullscreenDialog';
import { dataGridExtension } from 'components/devExtreme';
import { GetContextMenu } from 'api/shared/contextMenu';
import ContextMenu from 'devextreme-react/context-menu';
import CircularProgress from "@material-ui/core/CircularProgress";

const contextMenuRef = createRef();

const AuctionUWGrid = ({ selectedAuctionTxnOpps, selectedMarker, auctionGridCurrentViewData, auctionGridState, setAuctionGridState, viewValuationDialogIsOpen, setAuctionGridCurrentViewData,
  valuationIsDirty, setSaveUWDialogParameters, selectedTask, toggleViewValuationDialogIsOpen, setViewValuationDialogProps, classes, isInfoBoxOpen,
  isUserOwnedTask, setConfirmationModalState, orderInspection, refreshTxnInspection, runAutoCalc, updateBidInPrism, syncPurchaseState,
  updateVisibleTxnOpps, terminateTxnOpps, unterminateTxnOpps, deleteTxnOpps, setAuctionUWMarkerState, auctionUWMarkerState, uncapturedMarkers, setAuctionUWMapState, user, assignTasksTo,
  appSettings
}) => {

  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [viewInspectionDialogIsOpen, setViewInspectionDialogIsOpen] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [terminateDialogIsOpen, setTerminateDialogIsOpen] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageNavigating, setPageNavigating] = useState(false);
  const [isContextMenuVisible, setIsContextMenuVisible] = useState(false);
  const grid = useRef(null);
  let dataSource = useMemo(() => {
    const filterCaptured = selectedAuctionTxnOpps.filter(element => !auctionUWMarkerState.uncapturedMarkers.includes(element.id));
    return filterCaptured;
    // return selectedAuctionTxnOpps.map(opp => {
    //   const parsedDates = {};
    //   // if (opp.opportunityDate) parsedDates.opportunityDate = format(parseISO(opp.opportunityDate), 'MM/dd/yyyy');
    //   // if (opp.underContractDate) parsedDates.underContractDate = format(parseISO(opp.underContractDate), 'MM/dd/yyyy');
    //   // if (opp.auctionDate) parsedDates.auctionDate = format(parseISO(opp.auctionDate), 'MM/dd/yyyy');
    //   // if (opp.lastPrismPushDate) parsedDates.lastPrismPushDate = format(parseISO(opp.lastPrismPushDate), 'MM/dd/yyyy');
    //   return {
    //     ...opp,
    //     // ...parsedDates,
    //   }
    // })
  }, [selectedAuctionTxnOpps, auctionUWMarkerState.uncapturedMarkers])

  const onSetGridRef = g => {
    grid.current = g;
  }

  useEffect(() => {
    return () => {
      // Close ViewValuation dialog on unmount to fix the proforma heights on propUW pages
      if (viewValuationDialogIsOpen) {
        closeViewValuationDialog();
      }
      const newState = grid.current.instance.state();
      if (auctionGridState && auctionGridState.name) {
        newState.name = auctionGridState.name;
      }
      setAuctionGridState(newState);
    }
  }, []);

  useEffect(() => {
    if (grid.current) {
      grid.current.instance.beginUpdate();
      grid.current.instance.state(auctionGridState);
      grid.current.instance.endUpdate();
    }
  }, [auctionGridState]);

  useEffect(() => {
    if (selectedAuctionTxnOpps) {
      let currentViewIds = selectedAuctionTxnOpps.map(opp => opp.id);
      setAuctionGridCurrentViewData(currentViewIds);
    }
  }, [selectedAuctionTxnOpps]);

  useEffect(() => {
    if (grid.current && selectedMarker) {
      const gridRef = grid.current.instance;
      const dataIndex = auctionGridCurrentViewData.indexOf(selectedMarker.id);
      const dataIsUncaptured = auctionUWMarkerState.uncapturedMarkers.includes(selectedMarker.id);
      if (!gridRef.isRowFocused(selectedMarker.id) && dataIndex !== -1 && !dataIsUncaptured) {
        gridRef.option("focusedRowKey", selectedMarker.id);
        if (gridRef.getRowIndexByKey(selectedMarker.id) === -1) {
          setPageNavigating(true);
        }
      } else if (dataIndex === -1 || dataIsUncaptured) {
        gridRef.option("focusedRowIndex", -1);
      }
    } else if (grid.current) {
      const gridRef = grid.current.instance;
      gridRef.option("focusedRowIndex", -1);
    }
  }, [selectedMarker]);

  //#region Grid region
  const closeViewValuationDialog = () => {
    if (valuationIsDirty) {
      const route = `${Constants.Routes.UNDERWRITE_AUCTION}/${selectedTask.id}`;
      setSaveUWDialogParameters({ dialogIsOpen: true, route });
    } else {
      toggleViewValuationDialogIsOpen();
      setViewValuationDialogProps(null);
    }
  }

  const viewValuation = rowData => {
    const txnOpp = selectedAuctionTxnOpps.find(t => t.id === rowData.id);    // lookup the txnOpp, rowData only has data provided to the grid.
    toggleViewValuationDialogIsOpen();
    setViewValuationDialogProps(txnOpp);
  }
  //#endregion

  //#region Toolbar region
  const onToolbarPreparing = e => {
    if (uncapturedMarkers?.length > 0) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'excludedCount'
        },
      );
    }
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        template: 'totalCount'
      }
    );
  }

  const toolbarItemRender = (e) => {
    switch (e.template) {
      case 'totalCount':
        return totalCountTemplate();
      case 'excludedCount':
        return exludedCountTemplate();
      default:
        return;
    }
  }

  const totalCountTemplate = (e) => {
    return (<div className={classes.informer}>
      <span className={classes.countLabel}>{selectedAuctionTxnOpps.length}</span>
      <span className={classes.totalCountText}>Total Count</span>
    </div>)
  }

  const exludedCountTemplate = (e) => {
    return (<div className={classes.exclusionInformer}>
      <span className={classes.countLabel}>
        {uncapturedMarkers.length}
        <CloseIcon className={classes.exclusionRemoval} onClick={resetUncapturedProperties} />
      </span>
      <span className={classes.totalCountText}>Excluded</span>
    </div>)
  }

  const resetUncapturedProperties = (e) => {
    setAuctionUWMapState({ isDrawing: false });
    setAuctionUWMarkerState({ uncapturedMarkers: [] });
  }
  //#endregion

  //#region Context Menu
  const prepareContextMenu = (e) => {
    if (e.target === 'content') {
      // e.items can be undefined
      if (!e.items) e.items = [];
      if (e.row) {
        const { rowType } = e.row;
        if (rowType === 'data') {
          const ref = grid.current.instance;
          if (!ref.isRowSelected(e.row.key)) {
            ref.selectRows([e.row.key]);
          }
          e.items = []; // hide built-in context menu items since it doesn't support getting asynchronous items from server
          showCustomContextMenu(e); // fetch menu items from server and show custom context menu
        } else if (rowType === 'group') { }
      }
    }
  }

  const showCustomContextMenu = async (e) => {
    const selectedRows = grid.current.instance.getSelectedRowsData();
    const cellValue = findNestedValue(e.row.data, e.column.dataField);

    // show a empty context menu with loading spinner before we call backend server
    contextMenuRef.current.instance.option({ items: [{ text: "loading" }], target: e.targetElement });
    setIsContextMenuVisible(true);

    try {
      // Check for distinct channels, needs to only have 1 channel
      let channels = selectedRows.map(row => row.channelText);
      let distinctChannels = channels.filter((v, i, a) => a.indexOf(v) === i);
      if (distinctChannels > 1){
        appNotify("One or more transaction opportunities are in different channels", 'warning');
      }
      // Call server to get context menu items (assume the channel is based off the first selectedRow since you can't combine multiple channels)
      let contextMenuSettings = await GetContextMenu(selectedRows.map(row => row.id), 'AuctionGrid', selectedRows[0].channelText)

      let prevGroupNum = 0;
      var menuItems = contextMenuSettings.map(item => {
        let isBeginGroup = prevGroupNum !== item.group;
        prevGroupNum = item.group;

        let clickHandler = () => console.log(`No click handler found for ${item.actionDisplayName}`);

        switch (item.action) {
          case 'CopyCell':
            clickHandler = () => copyToClipboard(cellValue);
            break;
          case 'CopyRow':
            clickHandler = () => copyRow(selectedRows);
            break;
          case 'OrderInspection':
            clickHandler = () => handleOrderInspection(selectedRows);
            break;
          case 'ViewInspection':
            clickHandler = () => {
              setSelectedRowsData(selectedRows);
              handleViewInspection();
            };
            break;
          case 'SyncInspection':
            clickHandler = () => handleRefreshInspection(selectedRows);
            break;
          case 'CalcWithRepairs':
            clickHandler = () => handleCalcWithRepairs(selectedRows);
            break;
          case 'PushToCrm':
            clickHandler = () => handlePushToCrm(selectedRows);
            break;
          case 'SyncPurchaseState':
            clickHandler = () => handleSyncPurchaseState(selectedRows);
            break;
          case 'AssignOpportunity':
            clickHandler = () => handleAssign(selectedRows);
            break;
          case 'ShowOpportunity':
            clickHandler = () => handleShowOpp(selectedRows);
            break;
          case 'HideOpportunity':
            clickHandler = () => handleHideOpp(selectedRows);
            break;
          case 'ViewValuation':
            clickHandler = () => viewValuation(selectedRows[0]);
            break;
          case 'TerminateOpportunity':
            clickHandler = () => handleTerminate(selectedRows);
            break;
          case 'UnterminateOpportunity':
            clickHandler = () => handleUnterminate(selectedRows);
            break;
          case 'DeleteOpportunity':
            clickHandler = () => handleDeleteTxnOpps(selectedRows);
            break;
          default:
            break;
        }

        return {
          text: item.associateInfo ? `${item.actionDisplayName} (${item.associateInfo})` : item.actionDisplayName,
          beginGroup: isBeginGroup,
          disabled: !item.enabled,
          onItemClick: clickHandler
        }
      });

    } catch (error) {
      appNotify(error.message, 'error');
    }

    // show complete context menu with with data from backend server
    contextMenuRef.current.instance.option({ items: menuItems, target: e.targetElement });
    setIsContextMenuVisible(true);
  }

  function renderContextMenuItem(contextMenuItem, index) {
    /** When contextMenuItem.text is 'loading' we render a loading spinner instead of any text content,
     * which is a placeholer context menu we display before calling backend server to fetch real context menu items.
     * When contextMenuItem.text is not 'loading' it means our backend server call is finished and is populating
     * context menu with real data, now we just render the text content without any modification*/
    if (contextMenuItem.text === 'loading') {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress size={16} /></div>;
    }
    else {
      return <span>{contextMenuItem.text}</span>;
    }
  }

  const handleContextMenuItemClick = (e) => {
    // This is triggered when user clicked an option in context menu
    // e.itemData.items is to check if this context menu option has subitems
    if (!e.itemData.items) {
      //console.log(`The "${e.itemData.text}" item was clicked`);
      e.itemData.onItemClick();
    }
  }

  const handleContextMenuOptionChange = (e) => {
    // When user click outside of the context menu, an OptionChange event is raised with pramater e.fullName === 'visible' and e.value === false
    // We listen to this event and then set the IsContextMenuVisible state to e.value, which is false.
    if (e.fullName === 'visible') {
      setIsContextMenuVisible(e.value)  // e.value === false
    }
  }

  const onHidenContextMenu = (e) => {
    // We Need to clear the current contextMenu after its closed,
    // otherwise when user click in the same grid cell, 'onContextMenuPreparing' and thus we won't be able to get the most up-to-date context menu items
    contextMenuRef.current.instance.option({ items: [], target: null });
  }

  /**Copy Cell/Row */
  const copyToClipboard = (string) => {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = string;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
  }
  const copyRow = (selectedRows) => {
    const visibleColumns = grid.current.instance.getVisibleColumns().filter(col => col.dataField);
    const headerString = visibleColumns.map(col => col.caption).join('\t') + '\r\n';
    const combinedString = selectedRows.reduce((string, row) => {
      const rowValues = [];
      visibleColumns.forEach(col => {
        const value = findNestedValue(row, col.dataField);
        rowValues.push(value == null ? '\xa0' : value);
      });
      return string + rowValues.join('\t') + '\r\n';
    }, headerString);
    copyToClipboard(combinedString);
  }
  const findNestedValue = (row, dataField) => {
    if (!dataField) return undefined;
    let value = row;
    const split = dataField.split('.').filter(el => el !== '');

    for (const el of split) {
      if (value.hasOwnProperty(el)) {
        value = value[el];
      } else {
        value = undefined;
        break;
      }
    };
    return value;
  }

  /**Order Inspection */
  const handleOrderInspection = (selectedRowsData) => {
    const idsToOrderInspection = selectedRowsData.map(opp => opp.id);
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleOrderInspectionConfirmation(idsToOrderInspection),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to order drive by inspection for ${idsToOrderInspection.length} transaction opportunities?`
    });
  }
  const handleOrderInspectionConfirmation = (idsToOrderInspection) => {
    closeConfirmationModal();   // close confirm modal first
    orderInspection(idsToOrderInspection);
  };

  /**View Inspection */
  const handleViewInspection = () => {
    //show driveByInspectionLink from the txnOpp.adhocFields.driveByInspectionLink in a big modal
    setViewInspectionDialogIsOpen(true);
  }

  /**Sync Inspection */
  const handleRefreshInspection = (rowsToActOn) => {
    const idsToRefreshInspection = rowsToActOn.map(txnOpp => txnOpp.id);
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handRefreshInspectionConfirmation(idsToRefreshInspection),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to refresh inspection for ${idsToRefreshInspection.length} transaction opportunities?`
    });
  }
  const handRefreshInspectionConfirmation = (idsToRefreshInspection) => {
    closeConfirmationModal();   // close confirm modal first
    refreshTxnInspection(idsToRefreshInspection);
  }

  /**AutoCalc */
  const handleCalcWithRepairs = (rowsToActOn) => {
    const idsToRunCalculation = rowsToActOn.map(txnOpp => txnOpp.id);
    //console.log('idsToRunCalculation', idsToRunCalculation);
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleCalcWithRepairsConfirmation(idsToRunCalculation),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to calculate ${idsToRunCalculation.length} ${idsToRunCalculation.length > 1 ? 'valuations' : 'valuation'} with inspection repairs?`
    });
  }
  const handleCalcWithRepairsConfirmation = (idsToRunCalculation) => {
    closeConfirmationModal();
    //console.log('idsToRunCalculation', idsToRunCalculation);
    runAutoCalc(idsToRunCalculation);
  }

  /**Push to CRM */
  const handlePushToCrm = (rowsToActOn) => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handlePushToCrmConfirmation(rowsToActOn),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to push ${rowsToActOn.length} transaction opportunities to PRISM?`
    });
  }
  const handlePushToCrmConfirmation = (rowsToActOn) => {
    closeConfirmationModal();   // close confirm modal first
    const txnOpps = rowsToActOn;
    updateBidInPrism(txnOpps.map(opp => opp.id));
  };

  /**Sync purchase state */
  const handleSyncPurchaseState = (rowsToActOn) => {
    const idsToSyncPurchaseState = rowsToActOn.map(txnOpp => txnOpp.id);
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleSyncPurchaseStateConfirmation(idsToSyncPurchaseState),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to sync purchase state for ${idsToSyncPurchaseState.length} transaction opportunities?`
    });
  }
  const handleSyncPurchaseStateConfirmation = (idsToSyncPurchaseState) => {
    closeConfirmationModal();   // close confirm modal first
    syncPurchaseState(idsToSyncPurchaseState);
  }

  /**Include */
  const handleShowOpp = (rowsToActOn) => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleShowOppUWConfirmation(rowsToActOn),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to show ${rowsToActOn.length} transaction opportunities?`
    });
  }
  const handleShowOppUWConfirmation = (rowsToActOn) => {
    closeConfirmationModal();   // close confirm modal first
    let txnOppIds = rowsToActOn.map(txnOpp => txnOpp.id);
    updateVisibleTxnOpps(txnOppIds, Constants.Visibility.SHOW);
  }

  /**Exclude */
  const handleHideOpp = (rowsToActOn) => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleHideOppConfirmation(rowsToActOn),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to hide ${rowsToActOn.length} transaction opportunities?`
    });
  }
  const handleHideOppConfirmation = (rowsToActOn) => {
    closeConfirmationModal();   // close confirm modal first
    let txnOppIds = rowsToActOn.map(txnOpp => txnOpp.id);
    updateVisibleTxnOpps(txnOppIds, Constants.Visibility.HIDE);
  }

  /**Assign */
  const handleAssign = (rowsToActOn) => {
    setSelectedRowsData(rowsToActOn);
    setIsAssignModalOpen(true);
  }
  const assignTasks = (type, selectedRows, selectedUserId) => {
    const idsToAssign = type === 'auction' ? [selectedRows[0].portfolioId] : selectedRows.map(opp => opp.id);
    assignTasksTo(type, idsToAssign, selectedUserId, user.id); // Assign all tasks, whether coming from Imported, Available, or currently assigned to a user
    if (isAssignModalOpen) setIsAssignModalOpen(false);
  }

  /**Terminate */
  const handleTerminate = (rowsToActOn) => {
    setTerminateDialogIsOpen(true);
    setSelectedRowsData(rowsToActOn);
  }
  const terminateTasks = (selectedReason) => {
    const idsToTerminate = selectedRowsData.map(opp => opp.id);
    terminateTxnOpps(idsToTerminate, selectedReason);
    if (terminateDialogIsOpen) setTerminateDialogIsOpen(false);
  }

  /**Unterminate */
  const handleUnterminate = (selectedRows) => {
    setSelectedRowsData(selectedRows);
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => unterminateTasks(selectedRows),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to unterminate ${selectedRows.length} transaction ${selectedRows.length > 1 ? 'opportunities' : 'opportunity'}?`
    });
  }
  const unterminateTasks = (selectedRows) => {
    const idsToUnterminate = selectedRows.map(opp => opp.id);
    unterminateTxnOpps(idsToUnterminate);
    closeConfirmationModal();
  }

  /**Delete TxnOpp */
  function handleDeleteTxnOpps(selectedRows) {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleDeleteConfirmation(selectedRows),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to delete ${selectedRows.length} transaction ${selectedRows.length > 1 ? 'opportunities' : 'opportunity'}?`
    });
  }
  function handleDeleteConfirmation(selectedRows) {
    closeConfirmationModal();   // close confirm modal first
    const idsToDelete = selectedRows.map(opp => opp.id);
    console.log('handleDeleteConfirmation');
    deleteTxnOpps(idsToDelete);
  }

  const closeInspectionModal = () => {
    setViewInspectionDialogIsOpen(false);
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }
  //#endregion

  const onFocusedRowChanged = (e) => {
    if (e?.rowElement?.[0]?.attributes?.['aria-rowindex']?.value != null) {// crazy, but e.row doesnt match e.rowElement
      let rowIndex = (parseInt(e.rowElement[0].attributes['aria-rowindex'].value, 10) - 1) % e.component.getDataSource().pageSize();
      let rowData = e.component.getVisibleRows()[rowIndex].data
      if (rowData.id !== selectedMarker?.id) {
        setAuctionUWMarkerState({ isFetchingImages: isInfoBoxOpen, selectedMarker: rowData });
      }
    }
  }

  const onPageChange = () => {//datagrid does not have this event
    if (!pageNavigating) {
      setAuctionUWMarkerState({ isFetchingImages: false, isInfoBoxOpen: false, selectedMarkerImages: [], selectedMarker: null });
    } else {
      setPageNavigating(false);
    }
  }

  const onContentReady = (grid) => {
    if (grid.component.pageIndex() !== pageIndex) {
      setPageIndex(grid.component.pageIndex());
      onPageChange();
    }

    let rows = grid.component.getVisibleRows();
    if (rows.length > 0) {
      rows.forEach(row => {
        if (row.data.isProcessing) {
          let rowEl = grid.component.getRowElement(row.rowIndex);
          if (rowEl) {
            if (rowEl[0]) {
              rowEl[0].classList.add('loadingRowColor');
            }
            if (rowEl[1]) {
              rowEl[1].classList.add('loadingRowColor');
              rowEl[1].classList.add('loadingRow');
            }
          }
        }
      });
    }
  }

  const onOptionChanged = e => {
    if (e.name === 'filterValue') { // If filter changed, update visible rows so map can pick up on it
      let visibleRowHomeIds;
      if (e.value != null) {
        const gridRef = grid.current.instance;
        const combinedFilter = gridRef.getCombinedFilter();
        visibleRowHomeIds = Query(selectedAuctionTxnOpps)
          .filter(combinedFilter)
          .toArray()
          .map(row => row.id);
      } else {
        visibleRowHomeIds = selectedAuctionTxnOpps.map(row => row.id);
      }
      setAuctionGridCurrentViewData(visibleRowHomeIds);
    }
  }

  const onExported = (e) => {
    sendClientLog('Info', `Auction UW - User exported grid to Excel. Portfolio ID ${selectedTask.id}`);
  }

  const sortFields = () => {
    let fields = appSettings.FieldSettings.filter(field => field.auctionGrid).map(c => ({ dataField: c.field, caption: c.displayName, dataType: c.type, format: c.format }));
    let getCaption = f => f.caption.length > 0 ? f.caption.toLowerCase() : f.dataField.toLowerCase();
    fields.sort((a, b) => {
      if (getCaption(a) < getCaption(b))
        return -1;
      if (getCaption(a) > getCaption(b))
        return 1;
      return 0;
    });
    return fields;
  }

  let columns = useMemo(() => {
    return appSettings.FieldSettings.filter(field => field.auctionGrid).map(({ field, displayName, width, type, format, headerFilter, auctionGrid }) => {
      const { visible, fixed, isIncomeColumnGroup, isExpenseColumnGroup, isRepairsColumnGroup, isOverrideColumn, isNegativeValue } = auctionGrid;
      const index = appSettings.FieldIndex.auctionGrid[field];
      let cellRender = null;
      if (field === 'opportunityStatus') {
        cellRender = (row) => {
          return <OpportunityStatusChip txnOpp={row.data} />
        }
      };
      if (field === 'viewValuation') {
        cellRender = (row) => {
          // only hight icon with red color when this txnOpp has completed valuation and bestFitIcbm is either stale or do not have bestFitIcbmOrder
          return <LaunchValuationButton rowData={row.data} handleViewValuation={viewValuation} color={(row.data.selectedValuationId && row.data.selectedValuationIsLatest === false) ? 'secondary' : 'action'}></LaunchValuationButton>
        }
      };
      if (type === 'boolean' || ['lastPrismPushDidSucceed', 'bid', 'isProcessing'].includes(field)) {
        cellRender = (cell) => {
          return <BoolIcon bool={cell.value} />
        }
      };
      // For auction owner we render the valuation dropdown, for other users we just show the selected valuation underwritter string name
      if (isUserOwnedTask && field === 'selectedValuationUserName') {
        cellRender = (row) => {
          const auctionTxnOpp = selectedAuctionTxnOpps.find(el => {
            return el.id === row.data.id;
          });
          console.log(auctionTxnOpp)
          return auctionTxnOpp
            ? <AuctionUWUnderwriterSelector
              auctionTxnOpp={auctionTxnOpp}
              selectedUnderwriter={row.data.selectedValuationUserName}
            />
            : null
        }
      }

      if (isNegativeValue) {
        cellRender = (row) => {
          let cellValue = row.values[row.columnIndex]  // find the cell value
          return <span className={classes.negativeValue}>{`(${cellValue})`}</span>
        }
      }

      let cssClass = null;  // this is column css
      if (isIncomeColumnGroup) {
        cssClass = classes.columnHighlightGreen;
      }
      if (isExpenseColumnGroup) {
        cssClass = classes.columnHighlightOrange;
      }
      if (isRepairsColumnGroup) {
        cssClass = classes.columnHighlightBlue;
      }


      let headerCellTemplate = null;
      if (isOverrideColumn) {
        headerCellTemplate = () => <span className={classes.overrideColumnHeader}>{displayName}</span>
      }

      return (
        <Column
          key={field}
          dataField={field}
          dataType={type === 'boolean' ? 'string' : type}//boolean generates hidden icons, adding weird space to header
          format={format}
          width={width || 'auto'}
          caption={displayName}
          visible={visible}
          fixed={fixed}
          allowResizing={true}
          allowEditing={false}
          allowSorting={field !== 'viewValuation'}
          allowFiltering={field !== 'viewValuation'}
          allowGrouping={true}
          showEditorAlways={false}
          headerCellRender={headerCellTemplate}
          cellRender={cellRender}
          cssClass={cssClass}
          visibleIndex={index}
          calculateSortValue={rowData => {
            if (rowData[field] == null) return null; // Converts undefined values to null for sorting purposes (otherwise null is considered as lowest value and undefined as highest value)
            return rowData[field];
          }}
        >
          <HeaderFilter dataSource={(options) => dataGridExtension.headerFilterSort(options, dataSource, field, type, headerFilter)} />
          {/* <ColumnHeaderFilter dataSource={dataGridExtension.headerFilterSort(dataSource, field, type, headerFilter)} /> */}
        </Column>
      )
    })
  }, [dataSource, selectedAuctionTxnOpps, isUserOwnedTask, grid]);

  return (
    <div style={{ height: 'calc(100% - 25px)' }}>
      <DataGrid
        id='auctionGrid' // Must match in ReVUeSetting.json for tooltips to work
        // columnAutoWidth={true}
        ref={onSetGridRef}
        dataSource={dataSource}
        keyExpr='id'
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode='widget'
        showRowLines={true}
        showColumnLines={true}
        hoverStateEnabled={true}
        onToolbarPreparing={onToolbarPreparing}
        onContextMenuPreparing={prepareContextMenu}
        columnAutoWidth={true}
        focusedRowEnabled={true}
        onContentReady={onContentReady}
        onFocusedRowChanged={onFocusedRowChanged}
        onOptionChanged={onOptionChanged}
        onExported={onExported}
        focusedRowKey={selectedMarker?.id}
        height={'100%'}
      >
        <Selection mode={'multiple'} showCheckBoxesMode='never' />
        <ColumnChooser enabled={true} search={{ enabled: true }} height={640} mode='select' />
        <ColumnFixing enable={true} />
        <Export enabled={true} fileName={'AuctionTxnOpps'} allowExportSelectedData={true} />
        <HeaderFilter visible={true} search={{ enabled: true }} hideSelectAllOnSearch={false} />
        <Sorting mode={'multiple'} />
        <FilterPanel visible={true} />
        <FilterBuilder fields={sortFields()}>
          {dataGridExtension.filterBuilderCustomOperations}
        </FilterBuilder>
        <SearchPanel visible={true} searchVisibleColumnsOnly={true} />
        <Paging defaultPageSize={25} />
        <Template name='totalCount' render={toolbarItemRender} />
        <Template name='excludedCount' render={toolbarItemRender} />
        {columns}

      </DataGrid>
      <ContextMenu
        ref={contextMenuRef}
        onItemClick={handleContextMenuItemClick}
        visible={isContextMenuVisible}
        onOptionChanged={handleContextMenuOptionChange}
        hideOnOutsideClick={true}
        itemRender={renderContextMenuItem}
        onHidden={onHidenContextMenu} />
      <FullscreenDialog
        open={viewValuationDialogIsOpen}
        onClose={closeViewValuationDialog}
        classes={{ dialogPaper: classes.viewValuationDialogPaper, paper: classes.viewValuationDialogInnerPaper }}
        disablePortal
        hideBackdrop
        title={`Return to Portfolio${selectedTask?.portfolioName ? ` (${selectedTask.portfolioName})` : ''}`}
      >
      </FullscreenDialog>
      <InspectionDialog isOpen={viewInspectionDialogIsOpen} onClose={closeInspectionModal} inspectionFileUrl={selectedRowsData[0] && selectedRowsData[0].inspectionFileUrl} inspectionJson={selectedRowsData[0] && selectedRowsData[0].inspectionJsonResponse} />
      <AssignModal
        selectedRows={selectedRowsData}
        isOpen={isAssignModalOpen}
        setIsOpen={setIsAssignModalOpen}
        assignTasks={assignTasks}
      />
      <TerminateModal
        txnOpps={selectedRowsData}
        isOpen={terminateDialogIsOpen}
        setIsOpen={setTerminateDialogIsOpen}
        terminateTasks={terminateTasks}
      />
    </div >
  )
};

const styles = theme => ({
  viewValuationDialogPaper: {
    zIndex: 2,
  },
  viewValuationDialogInnerPaper: {
    // height: '85vh',
    // overflowY: 'auto',
    display: 'flex'
  },
  viewValuationDialogContent: {
    // overflowY: 'visible',
    overflowY: 'auto',
    padding: '0!important',
    display: 'flex'
  },
  viewInspectionDialogPaper: {
    width: '85vw',
    height: '85vh',
    display: 'flex'
  },
  informer: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    width: '130px',
    background: '#80a4c7',
    color: '#fff',
    textAlign: 'center'
  },
  exclusionInformer: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    width: '130px',
    background: '#dbd676',
    color: '#fff',
    textAlign: 'center'
  },
  exclusionRemoval: {
    position: 'absolute',
    right: 18,
    top: 6,
    cursor: 'pointer'
  },
  countLabel: {
    fontSize: '18px',
    paddingTop: '5px',
    margin: '0'
  },
  totalCountText: {
    paddingBottom: '5px',
  },
  columnHighlightGreen: {
    backgroundColor: '#E4FCDC'
  },
  columnHighlightOrange: {
    backgroundColor: '#FFEBC8'
  },
  columnHighlightBlue: {
    backgroundColor: '#D6EFF5'
  },
  overrideColumnHeader: {
    color: 'red'
  },
  negativeValue: {
    color: '#D77474'
  }
});

const mapStateToProps = (state) => {
  return {
    auctionUWMarkerState: state.auctionUWState.auctionUWMarkerState,
    selectedMarker: state.auctionUWState.auctionUWMarkerState.selectedMarker,
    isInfoBoxOpen: state.auctionUWState.auctionUWMarkerState.isInfoBoxOpen,
    isFetchingImages: state.auctionUWState.auctionUWMarkerState.isFetchingImages,
    selectedMarkerImages: state.auctionUWState.auctionUWMarkerState.selectedMarkerImages,
    uncapturedMarkers: state.auctionUWState.auctionUWMarkerState.uncapturedMarkers,
    viewValuationDialogIsOpen: state.auctionUWState.viewValuationDialogIsOpen,
    viewValuationDialogProps: state.auctionUWState.viewValuationDialogProps,
    valuationIsDirty: state.propertyUWState.valuationIsDirty,
    selectedAuctionTxnOpps: selectedAuctionTxnOppsSelector(state),
    auctionGridCurrentViewData: state.auctionUWState.auctionGridCurrentViewData,
    auctionGridState: state.auctionUWState.auctionGridState,
    appSettings: state.appState.appSettings
  }
};

const mapDispatchToProps = dispatch => ({
  setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState)),
  terminateTxnOpps: (taskIds, reason) => dispatch(terminateTxnOpps(taskIds, reason)),
  unterminateTxnOpps: (txnOppIds) => dispatch(unterminateTxnOpps(txnOppIds)),
  deleteTxnOpps: (txnOppIds) => dispatch(deleteTxnOpps(txnOppIds)),
  syncPurchaseState: (txnOppIds) => dispatch(syncPurchaseState(txnOppIds)),
  setAuctionUWMarkerState: auctionUWMarkerState => dispatch(setAuctionUWMarkerState(auctionUWMarkerState)),
  runAutoCalc: (txnOppIds) => dispatch(runAutoCalc(txnOppIds)),
  setAuctionGridCurrentViewData: data => dispatch(setAuctionGridCurrentViewData(data)),
  setViewValuationDialogProps: props => dispatch(setViewValuationDialogProps(props)),
  toggleViewValuationDialogIsOpen: e => dispatch(toggleViewValuationDialogIsOpen()),
  setSaveUWDialogParameters: ({ dialogIsOpen, route }) => dispatch(setSaveUWDialogParameters({ dialogIsOpen, route })),
  orderInspection: (txnOppIds) => dispatch(orderInspection(txnOppIds)),
  updateBidInPrism: (txnOppIds) => dispatch(updateBidInPrism(txnOppIds)),
  updateVisibleTxnOpps: (txnOppIds, updateType) => dispatch(updateVisibleTxnOpps(txnOppIds, updateType)),
  refreshTxnInspection: (txnOppIds) => dispatch(refreshTxnInspection(txnOppIds)),
  unassignTasks: (taskType, taskIds, initiatedUserId) =>
    dispatch(unassignTasks(taskType, taskIds, initiatedUserId)),
  appNotify: (message, variant) => dispatch(appNotify(message, variant)),
  setAuctionUWMapState: auctionUWMapState => dispatch(setAuctionUWMapState(auctionUWMapState)),
  setAuctionGridState: state => dispatch(setAuctionGridState(state)),
  assignTasksTo: (taskType, taskIds, assignToUserId, initiatedUserId) => dispatch(assignTasksTo(taskType, taskIds, assignToUserId, initiatedUserId)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(AuctionUWGrid);
